import { useCallback, useEffect, useState } from "react"
import api from "../../api"
import { ReactComponent as CalendlyIcon } from "../../assets/images/icons/ic-calendly.svg"
import Button from "../Button"
import styles from "./CalendlyOrganizationSettings.module.css"

const EVENT_LABELS = {
  "invitee.created": "Appuntamento prenotato",
  "invitee.canceled": "Appuntamento annullato",
}

const CalendlyOrganizationSettings = () => {
  const [webhook, setWebhook] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState("")
  const [notice, setNotice] = useState("")

  const loadWebhook = useCallback(async () => {
    setLoading(true)
    setError("")
    try {
      setWebhook(await api.get("/admin/calendly/organization-webhook"))
    } catch (e) {
      setError(e?.detail || "Non è stato possibile verificare il webhook Calendly.")
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const result = params.get("calendly_organization")
    if (result === "connected") {
      setNotice("Webhook dell’organizzazione Calendly attivato correttamente.")
    } else if (result === "error") {
      setError(params.get("detail") || "Collegamento Calendly non riuscito.")
    }
    if (params.has("calendly_organization")) {
      window.history.replaceState({}, "", window.location.pathname)
    }
    loadWebhook()
  }, [loadWebhook])

  const connect = async () => {
    setLoading(true)
    setError("")
    setNotice("")
    try {
      const result = await api.post("/admin/calendly/organization-webhook/oauth/start")
      window.location.assign(result.authorization_url)
    } catch (e) {
      setError(e?.detail || "Non è stato possibile avviare il collegamento Calendly.")
      setLoading(false)
    }
  }

  return (
    <section className={styles.card}>
      <div className={styles.header}>
        <div className={styles.icon}><CalendlyIcon /></div>
        <div className={styles.identity}>
          <span className={styles.eyebrow}>Integrazione organizzazione</span>
          <h2>Webhook Calendly</h2>
          <p>Riceve nel CRM prenotazioni e cancellazioni di tutti i sales dell’organizzazione.</p>
        </div>
        <span className={`${styles.status} ${webhook?.connected ? styles.active : ""}`}>
          {loading && webhook === null ? "Verifica…" : webhook?.connected ? "Attivo" : "Non configurato"}
        </span>
      </div>

      <div className={styles.requirement}>
        <strong>Usa un account Calendly owner o admin.</strong>
        <span>Un normale account membro non può creare il webhook per tutta l’organizzazione.</span>
      </div>

      {notice && <div className={styles.notice} role="status">{notice}</div>}
      {error && <div className={styles.error} role="alert">{error}</div>}

      {webhook?.connected && (
        <div className={styles.details}>
          <div>
            <span>Account amministratore</span>
            <strong>{webhook.email || webhook.name || "Account Calendly"}</strong>
          </div>
          <div>
            <span>Eventi ricevuti</span>
            <div className={styles.events}>
              {(webhook.events || []).map(event => (
                <span key={event}>{EVENT_LABELS[event] || event}</span>
              ))}
            </div>
          </div>
          <div>
            <span>Endpoint</span>
            <code>{webhook.callback_url}</code>
          </div>
        </div>
      )}

      <div className={styles.actions}>
        <Button
          appearance="subtle"
          accentColor="var(--primary)"
          disabled={loading}
          onClick={connect}
        >
          {webhook?.connected ? "Ricollega account admin" : "Configura con Calendly"}
        </Button>
        {webhook?.connected && (
          <span className={styles.helper}>Il collegamento personale dei sales resta separato.</span>
        )}
      </div>
    </section>
  )
}

export default CalendlyOrganizationSettings
